import {ReactText} from 'react';
import {createReducer} from '@reduxjs/toolkit';
import {VariantType} from 'notistack';
import {notify, clearNotification} from './actions';

const initialState: {message: string; key: ReactText; variant: VariantType}[] = [];

export const notifications = createReducer(initialState, (builder) =>
    builder
        .addCase(notify, (state, action) => state.concat(action.payload))
        .addCase(clearNotification, (state, action) => state.filter((el) => el.key !== action.payload))
);
